import {
  Component,
  ComponentRef,
  EventEmitter,
  Injector,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChange,
  SimpleChanges,
  Type,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { InputType } from '@miq/catalog';
import { ComponentRenderer } from '../renderers/component-renderer';
import { AbstractAdvancedInput } from './abstract-advanced-input';
import { InputConfig, InputTypeToAdvancedInputMap } from './advanced-inputs.model';

@Component({
  selector: 'miq-advanced-input',
  template: ` <ng-container #selectorContainer></ng-container> `,
  styles: [],
  exportAs: 'inputControl',
  standalone: false,
})
export class AdvancedInputComponent implements OnInit, OnDestroy, OnChanges, ComponentRenderer<AbstractAdvancedInput> {
  @Input() public config: InputConfig = undefined;

  @Input() public currentValue: any;

  @Output() public currentValueChange: EventEmitter<any> = new EventEmitter();

  @ViewChild('selectorContainer', { read: ViewContainerRef, static: true })
  private container: ViewContainerRef;
  public input: ComponentRef<AbstractAdvancedInput>;

  private subscriptions: Subscription;

  constructor(private parentInjector: Injector) {}

  ngOnInit() {
    if (this.config?.inputType) {
      this.mountComponent(this.resolveComponentType());
      this.afterMountComponent();
    }
  }

  resolveComponentType(): Type<AbstractAdvancedInput> {
    return InputTypeToAdvancedInputMap.get(this.config.inputType as InputType);
  }

  mountComponent(component: Type<AbstractAdvancedInput>): void {
    this.input = this.container.createComponent(component, { injector: this.parentInjector });
    this.input.instance.configuration = this.config;
    this.input.instance.currentValue = this.currentValue;
  }

  afterMountComponent(): void {
    this.subscriptions = this.input.instance.currentValueChange.subscribe(newValue =>
      this.currentValueChange.emit(newValue)
    );
  }

  ngOnChanges({ config, currentValue }: SimpleChanges): void {
    if (config) {
      this.updateInputConfig(config);
    }
    if (currentValue) {
      this.updateCurrentValue(currentValue);
    }
  }

  private updateInputConfig(configSimpleChange: SimpleChange) {
    if (!configSimpleChange.firstChange && this.input && this.config) {
      this.input.instance.configuration = this.config;
    }
  }

  private updateCurrentValue(currentValueSimpleChange: SimpleChange) {
    if (!currentValueSimpleChange.firstChange && this.input) {
      this.input.instance.currentValue = currentValueSimpleChange.currentValue;
    }
  }

  ngOnDestroy() {
    if (this.input) {
      this.input.destroy();
      this.input = null;
    }
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
    this.container.clear();
    this.container = null;
  }
}
